import React from 'react';
import { string } from 'prop-types';
import { loader } from './styles';

const LoaderV2 = ({ width, height }) => {
  const loaderProps = {
    width,
    height
  };
  return <div className={loader(loaderProps)} />;
};

LoaderV2.propTypes = {
  height: string,
  width: string
};

LoaderV2.defaultProps = {
  height: '',
  width: ''
};

export default LoaderV2;
